import React, { useMemo } from "react";
import { ServiceAvailability } from '@hometown/react-hometown-lib';
import { trackProCardsViews } from "../../helpers/helpers";

const CustomerLandingPage = ({ apolloURL, availabilityReqId, gatsbyKey, serviceCardCallback, defaultTemplateName, defaultService, setIsVisible }) => {
    return (
        useMemo(() => 
        <div id="availability-booking">
            <ServiceAvailability
                apolloURL={apolloURL}
                availabilityReqId={availabilityReqId}
                imageStaticEnv={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                gatsbyKey={gatsbyKey}
                serviceCardCallback={serviceCardCallback}
                defaultTemplateName={defaultTemplateName}
                defaultService={defaultService}
                baseServiceId="62a9f2cd61706a135071a7e3"
                compareDaysAhead={process.env.COMPARE_DAYS_AHEAD}
                setIsVisible={setIsVisible}
                trackProCardsViews={trackProCardsViews}
            />
        </div>, [availabilityReqId]
        )
    )
}

export default CustomerLandingPage;
